import { Divider, Typography } from "@mui/material";

export default function SectionHeader(props: { title: string }) {
    return (
        <>
            <Typography color="primary.main" fontSize="medium">
                {props.title}
            </Typography>

            <Divider sx={{ mt: 2, mb: 2 }} />
        </>
    );
}
